import { Platform } from './Platform';
export const getMessagePlatform = isMobile => {
  return isMobile ? Platform.Mobile : Platform.Desktop;
};